var React = require('react');

function SectionTop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1200-.43H0s192.14,40,600,40S1200-.43,1200-.43Z","style":{"fill":"#fff"},"key":0}),React.createElement("path",{"d":"M600,39.57c407.86,0,600,40,600,40v-80s-192.14,40-600,40S0-.43,0-.43v80S192.14,39.57,600,39.57Z","style":{"opacity":"0.5"},"key":1})]);
}

SectionTop.defaultProps = {"viewBox":"0 0 1200 80"};

module.exports = SectionTop;

SectionTop.default = SectionTop;
